import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import './view.scss';

/**
 * Asset showcase card stack.
 *
 * Swiper handles the index, navigation and pagination, but the visual stacking
 * is done in CSS from each slide's position after the active one — that lets
 * the offsets, scales and opacities match the Figma frame exactly, which a
 * linearly interpolated effect can't. `virtualTranslate` stops Swiper moving
 * the wrapper, and `rewind` avoids the DOM reordering that loop mode does
 * (which would break the sibling selectors).
 */
document.querySelectorAll('[data-asset-showcase]').forEach((element) => {
	const slider = element.querySelector('.swiper');

	if (!slider) {
		return;
	}

	new Swiper(slider, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		speed: 500,
		rewind: true,
		virtualTranslate: true,
		grabCursor: true,
		navigation: {
			prevEl: element.querySelector('[data-slider-prev]'),
			nextEl: element.querySelector('[data-slider-next]'),
		},
		pagination: {
			el: element.querySelector('[data-slider-pagination]'),
			clickable: true,
		},
	});
});
